/**
 * Resolves with `promise`'s value, or `undefined` if it doesn't settle within `ms`. Resolve-based
 * (not reject-based) so callers never need a try/catch around it.
 *
 * Mirrors `apps/shared/util/auth/clearClientStorage.ts` — duplicated because the dependency
 * direction is apps → packages, so this package cannot import from `apps/shared`.
 */
export function withTimeout<T>(promise: Promise<T>, ms: number): Promise<T | void> {
  return Promise.race([promise, new Promise<void>((resolve) => setTimeout(resolve, ms))])
}
